import React, { Component } from 'react'
import {
  Form,
  Input,
  InputNumber,
  Button,
  DatePicker,
  TimePicker,
  Checkbox,
  Icon,
  Radio
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import {Helmet} from 'react-helmet'
import { graphql } from '../graphql'
import {
  jsonStringifyForGraphQL
} from '../utilities'
import { push } from '../history'
import './DoseForm.scss'

const RadioGroup = Radio.Group
const CheckboxGroup = Checkbox.Group
const FormItem = Form.Item

class AddDoseForm extends Component {
  state = {
    confirmDirty: false,
    uuid: 0
  }

  componentWillMount = () => {
    const doseId = _.get(this.props, 'match.params.doseId')
    const { form } = this.props
    form.getFieldDecorator('keys', { initialValue: [] })
    if (doseId) {
      this.setState({ editingDoseId: doseId })
      this.getDose(doseId)
    }
  }

  componentDidMount = () => {
    this.add()
  }

  getDose = (doseId) => {
    const queryString = `
      query {
        doseDetail(
          doseId: "${doseId}"
        ) {
          name,
          timeReminders {
            method,
            quantity,
            time
          },
          dateReminders,
          dateRemindersType,
          startDate,
          endDate,
          remaining
        }
      }
    `
    graphql(queryString).then((response) => {
      console.log('response:', response)
      const dose = _.get(response, 'data.doseDetail')
      console.log('dose:', dose)
      this.setState({ uuid: dose.timeReminders.length })
      const { form } = this.props
      _.forEach(dose.timeReminders, (o, i) => {
        form.getFieldDecorator(`timeReminders-${i}`)
        form.setFieldsValue({ [`timeReminders-${i}`]: moment(o.time) })
      })
      const newFormValues = {
        name: dose.name,
        keys: _.times(dose.timeReminders.length),
        dateRemindersType: dose.dateRemindersType,
        startDate: moment(dose.startDate),
        remaining: dose.remaining
      }
      form.setFieldsValue(newFormValues)
      if (dose.dateRemindersType === 'interval') {
        form.setFieldsValue({ intervalDate: dose.dateReminders.length })
      } else if (dose.dateRemindersType === 'weekdays') {
        const weekdaysDate = []
        _.forEach(dose.dateReminders, (o, i) => {
          if (o) weekdaysDate.push(i + 1)
        })
        form.setFieldsValue({ weekdaysDate })
      } else if (dose.dateRemindersType === 'birthControl') {
        const count = _.compact(dose.dateReminders).length
        form.setFieldsValue({ birthControlDate: `${count}+${28 - count}` })
      }
    })
  }

  calculateDateReminders = (values) => {
    const { dateRemindersType } = values
    const dateValue = values[`${dateRemindersType}Date`]
    let dateReminders = [true]
    if (dateRemindersType === 'interval') {
      dateReminders = _.times(dateValue, _.constant(false))
      dateReminders[0] = true
    } else if (dateRemindersType === 'weekdays') {
      dateReminders = _.times(7, _.constant(false))
      _.forEach(dateValue, (i) => { dateReminders[i - 1] = true })
    } else if (dateRemindersType === 'birthControl') {
      dateReminders = _.times(28, _.constant(true))
      if (dateValue === '28+0') {
        _.noop()
      } else if (dateValue === '21+7') {
        for (let i = 21; i < 28; i += 1) dateReminders[i] = false
      } else if (dateValue === '20+8') {
        for (let i = 20; i < 28; i += 1) dateReminders[i] = false
      }
    }
    return dateReminders
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        values.dateReminders = this.calculateDateReminders(values)
        if (values.dateRemindersType === 'weekdays') {
          values.startDate = moment().day('Monday')
        }
        const keys = values.keys
        console.log('values:', values)
        const timeReminders = _.map(keys, (k) => values[`timeReminders-${k}`])
        console.log(timeReminders)
        values.timeReminders = _.map(timeReminders, (time) => (
          {
            method: 'EXACT_TIME',
            time: moment(time).format(),
            quantity: 1
          }
        ))
        const dateRemindersString = jsonStringifyForGraphQL(values.dateReminders)
        const timeRemindersString = jsonStringifyForGraphQL(values.timeReminders)
        values.startDate.startOf('day')
        const doseId = _.get(this.props, 'match.params.doseId')
        if (doseId) {
          graphql(`
            mutation {
              updateDose(
                doseId: "${doseId}"
                name: "${values.name}",
                timeReminders: ${timeRemindersString},
                dateReminders: ${dateRemindersString},
                dateRemindersType: "${values.dateRemindersType}",
                startDate: "${moment(values.startDate).format()}",
                remaining: ${values.remaining || 1}
              ) {
                name
              }
            }
          `).then(() => { push('/doses') })
        } else {
          graphql(`
            mutation {
              addDose(
                name: "${values.name}",
                timeReminders: ${timeRemindersString},
                dateReminders: ${dateRemindersString},
                dateRemindersType: "${values.dateRemindersType}",
                startDate: "${moment(values.startDate).format()}",
                remaining: ${values.remaining || 1}
              ) {
                name
              }
            }
          `).then(() => { push('/doses') })
        }
      }
    })
  }

  handleConfirmBlur = (e) => {
    const value = e.target.value
    this.setState({ confirmDirty: this.state.confirmDirty || !!value })
  }

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true })
    }
    callback()
  }

  remove = (k) => {
    const { form } = this.props
    const keys = form.getFieldValue('keys')
    if (keys.length === 1) return
    form.setFieldsValue({
      keys: _.filter(keys, (key) => key !== k),
    })
  }

  add = () => {
    const { uuid } = this.state
    const { form } = this.props
    const keys = form.getFieldValue('keys')
    const nextKeys = keys.concat(uuid)
    form.setFieldsValue({ keys: nextKeys })
    this.setState({ uuid: uuid + 1 })
  }

  renderTimes = (formItemLayout, formItemLayoutWithOutLabel) => {
    const { getFieldDecorator, getFieldValue } = this.props.form
    const keys = getFieldValue('keys')
    const formItems = _.map(keys, (k, index) => {
      const format = 'HH:mm'
      const initValue = '06:00'
      return (
        <FormItem
          {...(index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
          label={index === 0 ? 'เวลาในแต่ละวัน' : ''}
          required={false}
          key={k}
        >
          {getFieldDecorator(`timeReminders-${k}`, { initialValue: moment(initValue, format) })(
            <TimePicker
              className="multiple-time-picker"
              format={format}
            />
          )}
          <Icon
            className="dynamic-delete-button"
            type="close-circle-o"
            disabled={keys.length === 1}
            onClick={() => this.remove(k)}
          />
        </FormItem>
      )
    })
    return formItems
  }

  renderDates = (dateRemindersType, formItemLayout) => {
    const { getFieldDecorator } = this.props.form
    if (dateRemindersType === 'interval') {
      return (
        <FormItem
          {...formItemLayout}
          label="เตือนทุกๆกี่วัน"
        >
          {getFieldDecorator('intervalDate', { initialValue: 1 })(
            <InputNumber
              min={1}
              max={9999}
              formatter={(value) => `${value} วัน`}
              parser={(value) => value.replace(' วัน', '')}
            />
          )}
        </FormItem>
      )
    } else if (dateRemindersType === 'weekdays') {
      const options = [
        { label: 'วันจันทร์', value: '1' },
        { label: 'วันอังคาร', value: '2' },
        { label: 'วันพุธ', value: '3' },
        { label: 'วันพฤหัส', value: '4' },
        { label: 'วันศุกร์', value: '5' },
        { label: 'วันเสาร์', value: '6' },
        { label: 'วันอาทิตย์', value: '7' },
      ]
      return (
        <FormItem
          {...formItemLayout}
          label="วันไหนบ้างในสัปดาห์"
        >
          {getFieldDecorator('weekdaysDate', { initialValue: ['1'] })(
            <CheckboxGroup options={options} />
          )}
        </FormItem>
      )
    } else if (dateRemindersType === 'birthControl') {
      return (
        <FormItem
          {...formItemLayout}
          label="รูปแบบของยาคุมกำเนิด"
        >
          {getFieldDecorator('birthControlDate', { initialValue: '28+0' })(
            <RadioGroup>
              <Radio value="28+0">28+0</Radio>
              <Radio value="21+7">21+7</Radio>
              <Radio value="20+8">20+8</Radio>
            </RadioGroup>
          )}
        </FormItem>
      )
    }
    return <div />
  }

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form
    const { editingDoseId } = this.state
    const dateRemindersTypeDefault = 'interval'
    const dateRemindersType = getFieldValue('dateRemindersType') || dateRemindersTypeDefault
    const formItemLayout = {
      labelCol: { xs: { span: 24 }, sm: { span: 6 }, },
      wrapperCol: { xs: { span: 24 }, sm: { span: 14 } }
    }
    const formItemLayoutWithOutLabel = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 20, offset: 4 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 14, offset: 6 },
      }
    }
    return (
      // <Form onSubmit={this.handleSubmit} style={{ padding: '15px' }}>
      <Form style={{ padding: '15px' }}>
        <Helmet>
          <title>{editingDoseId ? 'ข้อมูลโดสยา' : 'เพิ่มโดสยาใหม่'}</title>
        </Helmet>
        <h2 className="title">
          {editingDoseId ? 'ข้อมูลโดสยา' : 'โดสยาใหม่'}
        </h2>
        <br />
        <FormItem
          {...formItemLayout}
          label="ชื่อโดส"
          hasFeedback
        >
          {getFieldDecorator('name', { initialValue: 'Test dose', rules: [{ required: true, whitespace: true, message: 'ใส่ชื่อโดสยา' }] })(
            <Input placeholder="ชื่อโดสยา" />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="วิธีการเตือน"
        >
          {getFieldDecorator('dateRemindersType', { initialValue: dateRemindersTypeDefault })(
            <RadioGroup>
              <Radio value="interval">1 วันในช่วงวันที่กำหนด</Radio>
              <Radio value="weekdays">วันที่ระบุในสัปดาห์</Radio>
              <Radio value="birthControl">คุมกำเนิด</Radio>
            </RadioGroup>
          )}
        </FormItem>
        {this.renderDates(dateRemindersType, formItemLayout)}
        {dateRemindersType !== 'weekdays' &&
          <FormItem
            {...formItemLayout}
            label="วันที่เริ่มเตือน"
          >
            {getFieldDecorator('startDate', { initialValue: moment() })(
              <DatePicker placeholder="วันที่เริ่มเตือน" />
            )}
          </FormItem>
        }
        {this.renderTimes(formItemLayout, formItemLayoutWithOutLabel)}
        <FormItem {...formItemLayoutWithOutLabel}>
          <Button className="add-time-button" type="dashed" onClick={this.add}>
            <Icon type="plus" /> เพิ่มเวลา
          </Button>
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="จำนวนยาที่มี"
        >
          {getFieldDecorator('remaining', { initialValue: 1 })(
            <InputNumber
              min={1}
              max={9999}
            />
          )}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button className="submit-button" type="primary" htmlType="submit" size="large" onClick={(e) => this.handleSubmit(e)}>
            {editingDoseId ? 'แก้ไขโดสยา' : 'เพิ่มโดสยา'}
          </Button>
        </FormItem>
      </Form>
    )
  }
}

const WrappedAddDoseForm = Form.create()(AddDoseForm)
export default WrappedAddDoseForm



// WEBPACK FOOTER //
// ./src/DoseForm/DoseForm.js